// Hrefs only: this app never navigates a return target.
import { RETURN_TARGET_PARAM } from './returnTarget'

function withReturnTarget(url: string, returnTarget: string): string {
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${RETURN_TARGET_PARAM}=${encodeURIComponent(returnTarget)}`
}

export function signInHref(appBase: string, returnTarget: string | null): string {
  return returnTarget === null ? appBase : withReturnTarget(appBase, returnTarget)
}

export function signOutHref(logoutUrl: string, appBase: string): string {
  return withReturnTarget(logoutUrl, appBase)
}
